<editor
	*ngIf="tinyMceConfig"
	draggableEditor
	[control]="control!"
	[isDraggable]="isDraggable"
	(ngModelChange)="inputChanged($event)"
	[(ngModel)]="control.value"
	[init]="tinyMceConfig"></editor>
